export const DASHBOARD_ROUTER = "/dashboard";
export const CATEGORY_ROUTER = "/categories";
export const PROJECT_ROUTER = "/projects";
export const CAREER_CATEGORY_ROUTER = "/career-categories";
export const BLOG_ROUTER = "/blogs";
export const COMPLIANCE_ROUTER = "/compliance";
export const CONTACT_US_ROUTER = "/contact-us";
export const ENQUIRE_ROUTER = "/inquiries";
export const JOB_APPLY_ROUTER = "/job-apply";
export const CHANNEL_PARTNER_ROUTER = "/channel-partner";
export const TESTIMONIAL_ROUTER = "/testimonials";
export const ABOUT_US_ROUTER = "/about-us";
export const SETTINGS_ROUTER = "/settings";
export const LOGIN_ROUTER = "/login";
export const ERROR_ROUTER = "*";


export const ROUTE = {
  DASHBOARD: DASHBOARD_ROUTER,

  CATEGORY: {
    LIST: CATEGORY_ROUTER,
    NEW: `${CATEGORY_ROUTER}/new`,
  },

  PROJECT: {
    LIST: PROJECT_ROUTER,
    NEW: `${PROJECT_ROUTER}/new`,
  },

  TESTIMONIAL: {
    LIST: TESTIMONIAL_ROUTER,
    NEW: `${TESTIMONIAL_ROUTER}/new`,
  },

  SETTINGS: {
    LIST: SETTINGS_ROUTER,
    NEW: `${SETTINGS_ROUTER}/new`,
  },
  
  CAREER_CATEGORY: {
    LIST: CAREER_CATEGORY_ROUTER,
    NEW: `${CAREER_CATEGORY_ROUTER}/new`,
  },
  JOBAPPLY:{
    LIST : JOB_APPLY_ROUTER,
  },
  CHANNEL_PARTNER: {
    INDIVIDUAL: `${CHANNEL_PARTNER_ROUTER}/individual`,
    AGENCY: `${CHANNEL_PARTNER_ROUTER}/agency`,
  },
  ABOUT_US: {
    LIST: ABOUT_US_ROUTER,
    TEAMS: `${ABOUT_US_ROUTER}/teams`,
    SHOWCASE: `${ABOUT_US_ROUTER}/showcase`,
    OTHER_FIELDS: `${ABOUT_US_ROUTER}/other-fields`,
  },
  BLOG: {
    LIST: BLOG_ROUTER,
    NEW: `${BLOG_ROUTER}/new`,
  },
  COMPLIANCE: {
    LIST: COMPLIANCE_ROUTER,
    NEW: `${COMPLIANCE_ROUTER}/new`,
  },

};

export default ROUTE;
